@if (grouped) {
    <p-avatarGroup [styleClass]="class">
        @for (person of people; track person.id) { 
            @if(person.avatar && person.avatar_url) {
                <p-avatar [image]="person.avatar_url" [styleClass]="class" [size]="size" [shape]="shape" />
            } @else {
                <p-avatar
                [label]="person | initials"
                [styleClass]="class"
                [size]="size"
                [shape]="shape">
                </p-avatar>
            }
        }
    </p-avatarGroup>
} @else {
    @for (person of people; track person.id) {
        @if(person.avatar && person.avatar_url) {
            <p-avatar [image]="person.avatar_url" [styleClass]="class" [size]="size" [shape]="shape" />
        } @else {
            <p-avatar
            [label]="person | initials"
            [styleClass]="class"
            [size]="size"
            [shape]="shape">
            </p-avatar>
        }
    }
}